import React from "react"

import Layout from "../components/layout"
import MainContent from "../components/main"


const IndexPage = () => (
  <Layout>
    <div className="blocks-hero">
      <h1>Blocks Design System</h1>
    </div>
    <MainContent />
  </Layout>
);

export default IndexPage;
